import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import PreCasInterviewPage3, { IProps } from './index';
import { getPageStatus } from './utils';

const mapStateToProps = (state: ApplicationState): IProps => {
  const defaultValues = {
    workWhileStudy: undefined,
    maxWorkHoursPerWeek: '',
    whyWorkWhileStudy: '',
    whyWorkWhileStudyOther: '',
    affordCourseAndLivingWithoutWorking: undefined,
    affordCourseAndLivingWithoutWorkingNo: '',
    completeDegreeWorkCountry: '',
    expectedSalary: 0,
    furtherStudyInUk: undefined,
    furtherStudyCareerPlans: '',
  };

  const {
    workWhileStudy,
    maxWorkHoursPerWeek,
    whyWorkWhileStudy,
    whyWorkWhileStudyOther,
    affordCourseAndLivingWithoutWorking,
    affordCourseAndLivingWithoutWorkingNo,
    completeDegreeWorkCountry,
    expectedSalary,
    furtherStudyInUk,
    furtherStudyCareerPlans,
  } = { ...defaultValues, ...state.student.preCasInterview };

  const { complete } = getPageStatus({
    workWhileStudy,
    maxWorkHoursPerWeek,
    whyWorkWhileStudy,
    whyWorkWhileStudyOther,
    affordCourseAndLivingWithoutWorking,
    affordCourseAndLivingWithoutWorkingNo,
    completeDegreeWorkCountry,
    expectedSalary,
    furtherStudyInUk,
    furtherStudyCareerPlans,
  });

  return {
    complete,
    currentStep: 3,
    steps: 4,
    workWhileStudy,
    maxWorkHoursPerWeek,
    whyWorkWhileStudy,
    whyWorkWhileStudyOther,
    affordCourseAndLivingWithoutWorking,
    affordCourseAndLivingWithoutWorkingNo,
    completeDegreeWorkCountry,
    expectedSalary,
    furtherStudyInUk,
    furtherStudyCareerPlans,
    pageConfig: state.student.config.Interview.Page3,
  };
};

export default connect(mapStateToProps)(PreCasInterviewPage3);
